// Registrierung „Geplante Nachrichten" für die Shell (Integrator hängt die Arrays in extras/index.tsx ein).
import type { ExtraMenuItem, ExtraRoute } from '../index';
import { ScheduledPage } from './ScheduledPage';
import { ScheduleMessageDialog } from './ScheduleMessageDialog';

export { ScheduledPage } from './ScheduledPage';
export { ScheduleMessageDialog } from './ScheduleMessageDialog';
export { applyScheduledUpdate, SCHEDULED_KEY, scheduledListKey } from './realtime';

export const scheduledRoutes: ExtraRoute[] = [{ path: '/scheduled', element: ScheduledPage }];

export const scheduledMenuItems: ExtraMenuItem[] = [
  { id: 'schedule-message', label: 'Nachricht planen', slot: 'channelHeader', component: ScheduleMessageDialog, display: 'dialog' },
  { id: 'scheduled', label: 'Geplante Nachrichten', slot: 'userMenu', to: '/scheduled' },
];
